export const getloaderState = (state) =>
  state.getIn(["loaderReducer", "loaders"]);
